// extracted by mini-css-extract-plugin
module.exports = {"footer":"FullFooter_footer__et0uZ","middleModule":"FullFooter_middleModule__PPfR8"};